import React from "react";
import classNames from "classnames";
import { getOpacityClass } from "@utils";
import { PeriodGoalStats } from "@data-types/sport-stats/SportStatsTypes";

export const StatGrid = ({
	periods,
	statKey,
}: {
	periods: PeriodGoalStats[];
	statKey: "scoredGoals" | "concededGoals";
}) => {
	const maxValue = Math.max(...periods.map((period) => period[statKey] || 0));

	return (
		<>
			{periods.map((period, index) => {
				const value = period[statKey] || 0;
				const opacityClass = getOpacityClass(value, maxValue);

				let goalDistributionClassName = classNames(
					"tag--goald",
					{
						"tag--goald--unset": value === 0,
						"tag--goald--scored":
							statKey === "scoredGoals" && value !== 0,
						"tag--goald--conceded":
							statKey !== "scoredGoals" && value !== 0,
					},
					opacityClass
				);

				return (
					<td
						key={index}
						className="table__body__cell table__cell table__cell--xtny table__cell--w--goald u-type--center"
					>
						<span className={goalDistributionClassName}>
							{value}
						</span>
					</td>
				);
			})}
		</>
	);
};
